import { AxiosPromise } from 'axios';
import { SearchParams } from '../model/searchParams';
import { InvoiceRun, Value } from '../model/invoiceRun';
import { ODataFilterBuilder } from 'odata-filter-builder';
import { DefaultBackendHelper } from '../utils/backendHelper';
import { instance, URLS } from '.';
import { CONST } from '../utils/constants';

export interface BackendInvoiceRun {
  getInvoiceRun(id: string): AxiosPromise<InvoiceRun>;
  getInvoiceRuns(
    searchParams: SearchParams,
    dateFrom?: string,
    dateTill?: string
  ): AxiosPromise<Value>;
  addExecuteInvoiceRun(
    year: number,
    month: number,
    includeMonthlyInvoices: boolean,
    includeQuarterlyInvoices: boolean,
    includeHalfYearlyInvoices: boolean,
    includeYearlyInvoices: boolean
  ): AxiosPromise<number>;
  deleteInvoiceRun(id: string): AxiosPromise;
}

export const defaultBackendInvoiceRun: BackendInvoiceRun = {
  getInvoiceRun(id: string): AxiosPromise<InvoiceRun> {
    const url = `${URLS.invoiceRun}/GetSingle/${id}`;
    return instance.get<InvoiceRun>(url);
  },
  getInvoiceRuns(
    searchParams: SearchParams,
    dateFrom?: string,
    dateTill?: string
  ): AxiosPromise<Value> {
    var odfb = ODataFilterBuilder('and');

    if (dateFrom !== undefined) {
      odfb.ge(CONST.StartDate, dateFrom, false);
    }
    if (dateTill !== undefined) {
      odfb.le(CONST.StartDate, dateTill, false);
    }

    const url = DefaultBackendHelper.makeUrl(
      URLS.invoiceRunOdata,
      searchParams.dataOption,
      searchParams.orClauseFieldsIds,
      searchParams.filter,
      odfb
    );

    return instance.get<Value>(url);
  },
  addExecuteInvoiceRun(
    year: number,
    month: number,
    includeMonthlyInvoices: boolean,
    includeQuarterlyInvoices: boolean,
    includeHalfYearlyInvoices: boolean,
    includeYearlyInvoices: boolean
  ): AxiosPromise<number> {
    const url = `${URLS.invoiceRun}/AddExecute`;
    const data = {
      Year: year,
      Month: month,
      IncludeMonthlyInvoices: includeMonthlyInvoices,
      IncludeQuarterlyInvoices: includeQuarterlyInvoices,
      IncludeHalfYearlyInvoices: includeHalfYearlyInvoices,
      IncludeYearlyInvoices: includeYearlyInvoices,
    };
    return instance.post<number>(url, data);
  },
  deleteInvoiceRun(id: string): AxiosPromise {
    const url = `${URLS.invoiceRun}/${id}`;
    return instance.delete(url);
  },
};
